var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      on: {
        enter: _vm.enter,
        "after-enter": _vm.afterEnter,
        leave: _vm.leave,
        "after-leave": _vm.afterLeave,
      },
    },
    [_vm.isShow && _vm.isLeftLeave ? _vm._t("default") : _vm._e()],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }